import React, {useState, useEffect} from 'react';
import {ISpotlightRail} from '@dazn/lp-web/src/types/rail.types';
import Rail from '@dazn/lp-web/src/components/Rail/Rail';
import styles from '@dazn/lp-web/src/components/SpotlightRail/spotlight.module.css';
import SpotlightRailContent from '@dazn/lp-web/src/components/SpotlightRail/SpotlightRailContent';
import {spotlightRailProxy} from '@dazn/lp-web/src/proxies';
import fetchRails from '@dazn/lp-web/src/services/rail.service';
import classnames from 'classnames';

interface IProps {
    rail: ISpotlightRail;
    key: number;
    disableAnimation: boolean;
}

const SpotlightRail: React.FC<IProps> = ({
    rail: spotlightRail,
    disableAnimation
}) => {
    const [rail, setRail] = useState<ISpotlightRail | null>(spotlightRail);

    useEffect(() => {
        (async function () {
            try {
                const result = await fetchRails([
                    {
                        railId: spotlightRail.railId,
                        railParams: spotlightRail.railParams
                    }
                ]);
                setRail(spotlightRailProxy(spotlightRail, result?.[0]));
            } catch (err) {
                console.log(err);
            }
        })();
    }, []);

    if (!rail || !rail.tiles.length) {
        return null;
    }

    const isBackgroundImageAvailable = Boolean(
        rail?.image?.src || rail?.image?.default
    );
    return (
        <div
            className={classnames(styles.spotlightRail, {
                [styles.noBackgroundImage]: !isBackgroundImageAvailable
            })}
        >
            <SpotlightRailContent
                rail={rail}
                isBackgroundImageAvailable={isBackgroundImageAvailable}
                disableAnimation={disableAnimation}
            />
            <Rail
                rail={rail}
                isBackgroundImageAvailable={isBackgroundImageAvailable}
                disableAnimation={disableAnimation}
            />
        </div>
    );
};

export default SpotlightRail;
